<template>
  <div class="skullList">
    <div class="skullImg el-skeleton__item el-skeleton__image">
      <img src='../../static/images/LOGO_new.png' />
    </div>
    <div>
      <el-skeleton-item variant="text" />
      <el-skeleton-item variant="text" />
      <el-skeleton-item variant="text" class="skullTitle" />
      <div class="skullPrice">
        <el-skeleton-item variant="text" class="skullTitle" />
      </div>
      <div class="skullBids">
        <el-skeleton-item variant="text" class="skullTitle" />
        <el-skeleton-item variant="text" class="skullTitle" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'skeleton',
  data() {
    return {

    }
  },
  mounted() {},
  created() {},
  methods: {

  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/skeleton.vue